import { render, staticRenderFns } from "./RallyRounds.vue?vue&type=template&id=c8595db8&"
import script from "./RallyRounds.vue?vue&type=script&lang=ts&"
export * from "./RallyRounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports